import "../polyfills";
import Screen from "@bd-utils/screen";
import StartingWorld from "@bd-utils/starting-world";
import $ from "jquery";

const description = $(".js-description");

const dynamicFontSize = () => {
  const textLength = description.text().length;
  const fontSize = textLength > 500 ? "1rem" : "1.2rem";
  description.css("font-size", fontSize);
};

Screen.calculateCoverSize();
StartingWorld.calculateCoverSize();

setTimeout(() => {
  dynamicFontSize();
}, 100);

$(window).on("resize", () => {
  Screen.calculateCoverSize();
  StartingWorld.calculateCoverSize();
});
